<template>
  <b-tr>
    <b-td> {{ report.length }} Cases  </b-td>
    <b-td></b-td>
    <b-td></b-td>
    <b-td></b-td>
    <b-td></b-td>
    <b-td>
      <span v-if="!pageToken">All Records Loaded</span>
      <b-button v-else :disabled="!pageToken" @click="loadMore">Load More</b-button>
    </b-td>
    <b-td>
      <b-button
        v-if="true"
        @click="exportToCsv"
      >
        <span>Download </span>
        <font-awesome-icon
          :icon="{
            prefix:'fas',
            iconName: 'download'
          }"
        />
      </b-button>
    </b-td>
  </b-tr>
</template>

<script>
import downloadCsv from '@/helpers/mixins/download-csv'
import moment from 'moment';

export default {
    name: 'CrisisCasesTableFooter',
    mixins: [downloadCsv],
    props: {
      pageToken: {
        type: String,
        require: true,
        default: () => null,
      },
      report: {
        type: Array,
        require: true,
        default: () => null,
      },
    },
    methods: {
        loadMore() {
            this.$emit('input', {});
        },
        exportToCsv() {
          const mappers = [
              { header: 'Case Number', mapper: x => x.externalCaseId },
              { header: 'Date', mapper: x => x.created },
              { header: 'Campus', mapper: x => x.assignedInstitutionName },
              { header: 'Case Type', mapper: x => x.externalType },
              { header: 'Participant Id', mapper: x => x.externalParticipantId },
              { header: 'Presenting Issue', mapper: x => x.issues },
              { header: 'Notes', mapper: x => x.notes.note },
          ];

          let fileName = 'crisis_services_report';
          if (this.from) {
              fileName += `_from_${this.from.format('YYYY-MM-DD')}`;
          }

          if (this.through) {
              fileName += `_through_${this.through.format('YYYY-MM-DD')}`;
          } else {
              fileName += `_through_${moment().format('YYYY-MM-DD')}`;
          }

          fileName += '.csv';

          const csv = this.toCsv(this.report, mappers);
          this.downloadCsv(csv, fileName)
      }
    }
}
</script>

<style lang="scss">
    tfoot td {
      background-color: $dark-blue !important;
      color: white;
      font-weight: 700;
    }
</style>
